import Tween from "tween.ts";
import Animation from "../../../../../../src/animation/Animation";
import Line from "../../../../../../src/entities/Line/Line";
import { Coord } from "../../../../../../src/types/Interface";


export default class DrawLineAnimation extends Animation {
  constructor(Line: Line, readonly pCoord: Coord, readonly sCoord: Coord, readonly tCoord: Coord, onComp: () => void) {
    super();
    new Tween.Tween({ ...sCoord })
      .to({ x: tCoord.x, y: tCoord.y }, 1000)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((coord: Coord) => {
        Line.draw(pCoord, coord);
      })
      .onComplete(() => onComp())
      .start();
  }
}